import { PlatformPersonas } from './platform-personas.enum';

/**
 * @description Map of platform personas to their corresponding routing path.
 * This is used to generate the routing path for a given persona. url structure: {persona}/dashboard
 * @example
 * - /admin/dashboard
 * - /agency/dashboard
 * - /customer/dashboard
 */
export const platformPersonasRoutemap: Record<PlatformPersonas, string> = {
  [PlatformPersonas.COWBELL]: 'admin',
  [PlatformPersonas.AGENCY]: 'agency',
  [PlatformPersonas.CUSTOMER]: 'customer',
  [PlatformPersonas.DIGITAL]: 'da',
  [PlatformPersonas.CLUSTER]: 'cluster',
  [PlatformPersonas.CARRIER]: 'carrier',
  [PlatformPersonas.POOL]: 'pool',
  [PlatformPersonas.VENDOR]: 'vendor',
  [PlatformPersonas.MSSP]: 'mssp',
  [PlatformPersonas.RE_INSURER]: 'reinsurer',
  [PlatformPersonas.PREMIUM_PROCESSOR]: 'premiumprocessor',
  [PlatformPersonas.FRANCHISE]: 'admin',
  [PlatformPersonas.UNKNOWN]: 'unknown',
} as const;
